import http from '@/utils/request';
import { API_BASE } from '@/config/index';

// 查看电子码单
export function getElectronCodeSheet(params) {
  const url = `${API_BASE.base}/order/electronic/code/${params}`;
  return http.get({
    url,
    loading: false,
  });
}

// 查看电子码单
export function getNewElectronCodeSheet(params) {
  const url = `${API_BASE.base}/tradingServer/order/code/detail`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

// 确认电子码单
export function confirmElectronCodeSheet(data) {
  const url = `${API_BASE.base}/order/common/direct/code/confirm`;
  return http.put({
    url,
    data,
    loading: false,
  });
}

// 确认电子码单 - 新订单
export function confirmNewElectronCodeSheet(data) {
  const url = `${API_BASE.base}/tradingServer/order/detail/confirm`;
  return http.put({
    url,
    data,
    loading: false,
  });
}


// 获取订单详情-直销
export function getDirectSaleOrderDetails(params) {
  const url = `${API_BASE.base}/order/api/invoke?v=1.0&exec=YpbOrderInfoBaseDetail`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

// 获取财务详情-直销
export function getDirectSaleFinanceDetails(params) {
  const url = `${API_BASE.base}/order/api/invoke?v=1.0&exec=YpbOrderFinancialInfo`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

// 登陆
export function accountLogin(data, headers) {
  const url = `${API_BASE.base}/auth/login_by_password`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 获取加密key
export function getAuthorityConfig() {
  return http.get({
    url: `${API_BASE.base}/authManage/authority/query_config`,
    loading: false,
  });
}

// 获取账号基本信息
export function getAccountInfo(data, headers) {
  const url = `${API_BASE.base}/baseServer/account/info`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 获取账号详情
export function getAccountDetail(data, headers) {
  const url = `${API_BASE.base}/baseServer/account/detail`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 获取验证码
export function getSmsVerifyCode(params, headers) {
  const url = `${API_BASE.base}/auth/send_ssm?mobilePhone=${params.phone}`;
  return http.get({
    url,
    config: {
      headers,
    },
    loading: false,
  });
}

// 注册
export function accountRegister(data, headers) {
  const url = `${API_BASE.base}/baseServer/account/register`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 注册
export function resetPasswordWithCaptcha(data, headers) {
  const url = `${API_BASE.base}/authManage/authority/user/password/reset_with_captcha`;
  return http.put({
    url,
    data,
    config: {
      headers,
    },
    loading: true,
  });
}

// 完善信息
export function accountSave(data, headers) {
  const url = `${API_BASE.base}/baseServer/account/save`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 完善信息
export function accountUpdate(data, headers) {
  const url = `${API_BASE.base}/baseServer/account/update`;
  return http.post({
    url,
    data,
    config: {
      headers,
    },
    loading: false,
  });
}

// 查看电子码单 获取码单二维码内容
export function getNewQrCodeContent(params) {
  const url = `${API_BASE.base}/tradingServer/order/code/v2/qr_baibu_order_code_content`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

// 查看电子码单 查询码单二维码内容
export function checkQrCodeContentUrl(params) {
  const url = `${API_BASE.base}/tradingServer/order/code/qrCodeContentUrl`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

export function getQrCodeContent(params) {
  const url = `${API_BASE.base}/tradingServer/direct/order/code/qr_code_content`;
  return http.get({
    url,
    params,
    loading: false,
  });
}

// 获取待确认码单列表
export function appletOrderPage(data) {
  const url = `${API_BASE.base}/tradingServer/color_card_station/applet/order/page`;
  return http.post({
    url,
    data,
  });
}

// 获取协议阅读链接
export function getAgreementUrl(data) {
  const url = `${API_BASE.base}/accountant/purchaser-bill/app/agreement/url`;
  return http.get({
    url,
    params: data,
  });
}

// 查询协议阅读状态
export function getAgreementStatus(data) {
  const url = `${API_BASE.base}/accountant/purchaser-bill/app/agreement/read-status`;
  return http.get({
    url,
    params: data,
    loading: false,
  });
}

// 自动完善信息
// export function accountUserSign(data, headers) {
//   const url = `${API_BASE.base}/authManage/user/sign`;
//   return http.post({
//     url,
//     data,
//     config: {
//       headers,
//     },
//     loading: false,
//   });
// }
